import React, { useEffect, useState } from 'react'
import MyTasksBar from './MyTaskBar'
import MyTasksTable from './MyTasksTable'
import { getMyTasks } from 'src/app/modules/administration/components/user/core/_requests'
import { useNavigate, useSearchParams } from 'react-router-dom'

const MyTasksListing = () => {
  const [ tasks, setTasks] = useState<any[]>([])
  const [summaryData, setSummaryData] = useState<any[]>([])
  const [loading, setLoading] = useState(false)
  const [searchParams, setSearchParams] = useSearchParams()
  const navigate = useNavigate();
  // Get filter values from URL query params
  const [statusFilter, setStatusFilter] = useState(searchParams.get('status') || '')
  const [priorityFilter, setPriorityFilter] = useState(searchParams.get('priority') || '')

  const handleSelectedColumn = () => {
    const newArr: Column[] = []
    columns.forEach((item) => {
      if (item.isChecked) newArr.push(item)
    })
    setNewColumns(newArr)
  }

  interface Tasks {
    id: number
    priorit?: string
    taskName?: string
    taskType?: string
    taskCode?: number
    tat?: string
    createdDate?: string
    [key: string]: any
  }

  interface Column {
    id: number
    isChecked: boolean
    path?: string
    label: string
    alignBody: string
    alignHeader: string
    content: (task: Tasks, index?: number) => React.ReactNode
  }

  const [newColumns, setNewColumns] = useState<Column[]>([])
  const [columns, setColumns] = useState([
    {
      id: 1,
      isChecked: true,
      path: 'code',
      label: 'Task Code',
      alignBody: 'text-left align-middle ps-3',
      alignHeader: 'text-center fw-bold ps-3',
      content: (task: any, index: any) => (
        <div key={1} className='d-flex align-items-center w-fitContent cursor-pointer'>
          <span className='ms-2'>
            <h5 className='m-0 text-decoration-none text-primary' onClick={() => navigate(`/process/process-access/${task?.processDesignCode}/tasks/${task?.code}`)} > {task?.code}</h5>
          </span>
        </div>
      ),
    },
    {
      id: 2,
      isChecked: true,
      path: 'name',
      label: 'Task Name',
      alignBody: 'text-left align-middle',
      alignHeader: 'text-center fw-bold',
      content: (task: any) => (
        <span key={2} className='m-0'>
          <div className='m-0'>{task?.name}</div>
        </span>
      ),
    },
    {
      id: 3,
      isChecked: true,
      path: 'taskType',
      label: 'Task Type',
      alignBody: 'text-left align-middle',
      alignHeader: 'text-center fw-bold',
      content: (task: any) => (
        <span key={2} className='m-0'>
          <div className='m-0'>{task?.taskType}</div>
        </span>
      ),
    },
    {
      id: 4,
      isChecked: true,
      path: 'turnAroundTime',
      label: 'TAT',
      alignBody: 'text-center align-middle',
      alignHeader: 'text-center fw-bold',
      content: (task: any) => (
        <span key={2} className='m-0'>
          <div className='m-0'>{task?.turnAroundTime}</div>
        </span>
      ),
    },
    {
      id: 5,
      isChecked: true,
      path: 'taskDate',
      label: 'Task Date',
      alignBody: 'text-left align-middle',
      alignHeader: 'text-center fw-bold',
      content: (task: any) => (
        <span key={2} className='m-0'>
          <div className='m-0'>{task?.taskDate ? new Date(task.taskDate).toLocaleDateString() : '-'}</div>
        </span>
      ),
    },
  ])

  const fetchMyTasks = async (status?: string, priority?: string) => {
    setLoading(true)
    try {
      const response = await getMyTasks(status, priority)
      if (response) {
        // Map tasks data
        setTasks(response.tasks || [])

        // Map summary data to format needed by MyTasksBar
        if (response.summary) {
          const summaryArray = Object.entries(response.summary).map(([label, count]) => ({
            label,
            count: count as number,
          }))
          setSummaryData(summaryArray)
        }
      }
    } catch (error) {
      console.error('Error fetching my tasks:', error)
    } finally {
      setLoading(false)
    }
  }

  // Handle filter changes
  const handleFilterChange = (filterType: 'status' | 'priority', value: string) => {
    const newParams = new URLSearchParams(searchParams)

    if (value) {
      newParams.set(filterType, value)
    } else {
      newParams.delete(filterType)
    }

    setSearchParams(newParams)

    if (filterType === 'status') {
      setStatusFilter(value)
    } else {
      setPriorityFilter(value)
    }
  }

  // Fetch tasks when filters change
  useEffect(() => {
    const status = searchParams.get('status') || ''
    const priority = searchParams.get('priority') || ''

    setStatusFilter(status)
    setPriorityFilter(priority)

    fetchMyTasks(status, priority)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams])

  useEffect(() => {
    handleSelectedColumn()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <div className='p-4 mb-4 bg-white rounded'>
        <MyTasksBar tasks={summaryData} />
      </div>

      {/* Filter Section */}
      <div className='p-4 bg-white rounded'>
        <div className='row g-3'
        style={{justifyContent:'end'}}>
          <div className='col-md-6 col-lg-3'>
            <select
              className='form-select'
              value={statusFilter}
              onChange={(e) => handleFilterChange('status', e.target.value)}
            >
              <option value=''>Select Status</option>
              <option value='NEW'>NEW</option>
              <option value='IN_PROGRESS'>IN_PROGRESS</option>
              <option value='COMPLETED'>COMPLETED</option>
            </select>
          </div>
          <div className='col-md-6 col-lg-3'>
            <select
              className='form-select'
              value={priorityFilter}
              onChange={(e) => handleFilterChange('priority', e.target.value)}
            >
              <option value=''>Select Priority</option>
              <option value='NORMAL'>NORMAL</option>
              <option value='LOW'>LOW</option>
              <option value='MEDIUM'>MEDIUM</option>
              <option value='URGENT'>URGENT</option>
            </select>
          </div>
        </div>
      </div>

      <div className='mb-8 bg-white p-5 rounded'>
        <MyTasksTable
          accounts={tasks}
          sortColumn={''}
          onSort={() => { }}
          setSelectedRows={() => { }}
          newColumns={newColumns}
          tableRef={null}
          selectedRows={[]}
          handleRowClick={(item: any) => { }}
          loading={loading}
          handleSelectAll={() => { }}
        />

        {/* <PaginationPerPage
          perPage={10}
          pageNo={1}
          onPerPageChange={handlePerPageChange}
          totalCount={0}
          onPageChange={handlePageChange}
          access_key='tasksListing'
          paginate={paginate ?? {}}
        /> */}
      </div>
    </>
  )
}

export default MyTasksListing
